(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-get-pixel", [], factory);
	else if(typeof exports === 'object')
		exports["layer-get-pixel"] = factory();
	else
		root["layer-get-pixel"] = factory();
})(self, function() {
return 